<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M10.999 6.006h5.005v-6.006h-5.005c-3.845 0.050-6.948 3.155-6.996 6.995l-0 0.005v3.003h-4.004v6.006h4.004v15.992h6.006v-16.001h5.005l1.001-6.006h-6.006v-3.003c-0.001-0.012-0.001-0.027-0.001-0.041 0-0.522 0.423-0.945 0.945-0.945 0.016 0 0.032 0 0.048 0.001l-0.002-0z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
